import React, { useEffect } from 'react'
import {
  resetCrossClientResults,
  selectCrossClientPageResults,
  setCrossClientResultsExecution,
  setCrossClientResultsExecutionLoading,
  setCrossClientTeammates,
  setCrossClientTeammatesLoading,
} from '../../../store/crossClient/crossClientResults'
import { useLazyGetCrossClientQueryExecutionQuery } from '../../../store/crossClient/crossClient'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useLazyGetAllUsersQuery } from '../../../store/user/user'
import { useFetchMissingCrossClientClients } from './hooks'

export interface CrossClientResultsInitializationProps {
  executionId: string
}

export const CrossClientResultsInitialization: React.FC<CrossClientResultsInitializationProps> = ({ executionId }) => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const pageResults = useAppSelector(selectCrossClientPageResults)

  const [triggerGetCrossClientQueryExecution] = useLazyGetCrossClientQueryExecutionQuery()
  const [triggerGetAllUsers] = useLazyGetAllUsersQuery()
  const fetchMissingClients = useFetchMissingCrossClientClients()

  useEffect(() => {
    const getExecution = async () => {
      try {
        dispatch(setCrossClientResultsExecutionLoading(true))
        const execution = await triggerGetCrossClientQueryExecution({ accountId, executionId }).unwrap()
        if (!execution) {
          return
        }
        dispatch(setCrossClientResultsExecution(execution))
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(setCrossClientResultsExecutionLoading(false))
      }
    }
    getExecution()
  }, [dispatch, accountId, executionId, triggerGetCrossClientQueryExecution])

  useEffect(() => {
    const getCrossClientTeammates = async () => {
      try {
        const teammates = await triggerGetAllUsers({ accountId, identityTypes: ['idp'] }).unwrap()
        if (teammates?.data) {
          dispatch(setCrossClientTeammates(teammates.data))
        }
      } finally {
        dispatch(setCrossClientTeammatesLoading(false))
      }
    }
    getCrossClientTeammates()
  }, [dispatch, accountId, triggerGetAllUsers])

  useEffect(() => {
    if (!pageResults.length) {
      return
    }
    fetchMissingClients(pageResults.map((result) => result.clientId)).catch(() => {})
  }, [pageResults, fetchMissingClients])

  useEffect(() => {
    return () => {
      dispatch(resetCrossClientResults())
    }
  }, [dispatch])

  return null
}
